

<!-- MODAL HEADER-->
<div class="row modal-bar">
  <div class="col-sm-9">
      <h5 class="modal-title">{{ passedData.title | translate }}</h5>
  </div>
  <div class="col-sm-3">
      <div class="modal-actions">
          <div class="modal-close">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
          </div>
      </div>
  </div>
</div>


<form [formGroup]="form" class="form-content">

  <div class="section-wrapper">
    <div class="form-layout">
      <div class="row">

        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'VIEWS.IPWHITELISTING.FIELDS.IPADDRESS' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control" name="ipaddress" formControlName="IPAddress" [placeholder]="'VIEWS.IPWHITELISTING.FIELDS.IPADDRESS' | translate" maxlength="15">
            <t4-display-validation controlName="IPAddress" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'VIEWS.IPWHITELISTING.FIELDS.DESCRIPTION' | translate}}<span class="tx-danger">*</span></label>
            <input class="form-control" name="description" formControlName="Description" [placeholder]="'VIEWS.IPWHITELISTING.FIELDS.DESCRIPTION' | translate" maxlength="128">
            <t4-display-validation controlName="Description" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>

      </div>

     
      <div class="form-layout-footer row mg-t-25">
        <div class="col-6">
          <button (click)="submit()" [disabled]="form.invalid || saving" class="btn btn-block btn-primary bd-0"><i
            class="far fa-save"></i><span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span></button>
        </div>
        <div class="col-6">
          <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0"><i
            class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
        </div>

      </div><!-- form-layout-footer -->
    </div><!-- form-layout -->
  </div>


</form>
